import { FC } from 'react'
import { Modal } from 'ui/Modal'
import { useTranslation } from 'react-i18next'
import { EditPriceForm } from './EditPriceForm'
import { OrderPurchaseItem } from '@trybeapp/sdk'

interface EditItemPriceOverlayProps {
  onCancel: () => void
  isOpen?: boolean
  item: OrderPurchaseItem
}

export const EditItemPriceOverlay: FC<EditItemPriceOverlayProps> = ({
  onCancel,
  isOpen = false,
  item,
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={t('orders.order_details.items.edit_price_overlay.title')}
    >
      <EditPriceForm onCancel={onCancel} item={item} />
    </Modal>
  )
}
